export enum LeverageValues {
  VALUE_1 = 5,
  VALUE_2 = 10,
  VALUE_3 = 25,
  VALUE_4 = 50,
}